<template>
  <a @click="trigger">
    <slot>
      <MIcon name="eye" class="mr-2 cursor-pointer text-primary center" />
    </slot>
    <FlotoDrawer :open="isDrawerOpen" width="65%" @hide="handleHide">
      <template v-slot:title>
        {{ `${status === 'failed' ? $tc('error') : $tc('success')}` }}
      </template>
      <div>
        <span v-for="m in message.split('@__@') || []" :key="m">
          <ul class="sorted-list">
            <li>{{ m }}</li>
          </ul>
        </span>
      </div>

      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
export default {
  name: 'ViewError',
  props: {
    message: { type: String, default: '' },
    status: { type: String, default: undefined },
  },
  data() {
    return {
      isDrawerOpen: false,
    }
  },
  methods: {
    trigger() {
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
    },
    handleHide() {
      setTimeout(() => {
        this.isDrawerOpen = false
      }, 400)
    },
  },
}
</script>
